<template>
  <div class="personal-data">
    <div class="wrapper">
      <div class="wrapList">
        <div class="item acea-row row-between-wrapper on">
          <div class="picTxt acea-row row-between-wrapper" style="width: 100%;">
            <div class="title" style="width:100%;text-align: center;">
              请完成实名认证
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper" style="font-size: small;">
        <div>真实姓名</div>
        <div class="input">
          <input
            :placeholder="'请输入真实姓名'"
            type="text"
            v-model="post.name"
          />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" style="font-size: small;">
        <div>身份证号</div>
        <div class="input">
          <input
            :placeholder="'请输入身份证号'"
            type="text"
            v-model="post.idCard"
          />
        </div>
      </div>
    </div>
    <div
      class="remind"
      style="font-size:12px;text-align:center;margin-top: 32px;"
    >
      注：请填写本人真实姓名和身份证号，一旦绑定，不可更改！
    </div>
    <div
      style="font-size:12px;text-align:center;margin-top: 32px;margin-left: 10px"
    >
      <div class="select-btn">
        <div class="checkbox-wrapper">
          <label class="well-check"
            ><input
              type="checkbox"
              name="default"
              value=""
              :checked="isCheck"
              @click="read()"
            /><i class="icon"></i
            ><span class="default"
              >我已阅读并同意
              <router-link :to="'/user/service_protocol/'" class="item">
                <a style="color: blue;">《用户服务协议》</a>、
              </router-link>
              <router-link :to="'/user/privacy_protocol/'" class="item">
                <a style="color: blue;">《隐私协议》</a>
              </router-link>
              <!-- <br />
              <router-link :to="'/user/spread_protocol/'" class="item">
                <a style="color: blue;">《推广合作协议》</a>
              </router-link> -->
            </span></label
          >
        </div>
      </div>
    </div>
    <div class="modifyBnt bg-color-red" @click="Identification()">确定</div>
  </div>
</template>
<script>
import { postIdentification, getUserInfo } from "@/api/user";

export default {
  name: "UserIdentification",
  data() {
    return {
      post: {
        name: "",
        idCard: ""
      },
      taskId: 0,
      isTask: false,
      isSuccess: 0,
      url: "",
      isCheck: false
    };
  },
  mounted: function() {
    this.taskId = this.$route.query.taskId;
    this.url = this.$route.query.url;
    if (this.taskId !== undefined) {
      this.isTask = true;
    }
  },
  methods: {
    read: function() {
      this.isCheck = !this.isCheck;
    },
    Identification: function() {
      if (this.isCheck === false) {
        this.$dialog.message("请阅读并同意《用户服务协议》和《隐私协议》");
        return;
      }
      let save = {
          name: this.post.name,
          idCard: this.post.idCard
        },
        that = this;
      let regName = /^[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF\u2000-\u2FA1·]+$/;
      if (
        this.post.name === "" ||
        this.post.name === undefined ||
        this.post.name == null
      ) {
        that.$dialog.message("请输入姓名");
        return false;
      } else {
        if (regName.test(this.post.name) === false) {
          that.$dialog.message("姓名输入不合法");
          return false;
        }
      }
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (
        this.post.idCard === "" ||
        this.post.idCard === undefined ||
        this.post.idCard == null
      ) {
        that.$dialog.message("请输入身份证号码");
        return false;
      } else {
        if (!reg.test(this.post.idCard) && this.post.idCard !== "") {
          that.$dialog.message("身份证输入不合法");
          return false;
        }
      }
      postIdentification(save).then(res => {
        that.isSuccess = res.data.isSuccess;
        if (that.isSuccess == 1) {
          that.$dialog.message("认证成功");
          this.onload();
          if (this.isTask) {
            this.$router.push({
              path: "/taskDetail/" + this.taskId,
              query: {
                toFinish: "toFinish"
              }
            });
          } else {
            if (this.url !== undefined) {
              let h5Url = this.url;
              window.location.href = h5Url;
            }
            this.$router.push({
              path: "/user"
            });
          }
        } else {
          that.$dialog.message("认证失败");
        }
      });
    },
    onload: function() {
      getUserInfo(2).then(res => {
        this.$store.commit("UPDATE_USERINFO", res.data);
      });
    }
  }
};
</script>

<style></style>
